var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menhu-main"},[_c('m-header'),_c('router-view',{staticClass:"con"}),_c('m-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }